import type {
  SurveyNotifier,
  SurveyNotifiersResponse,
} from "@survey-types/survey.core.types";
import { surveyApi } from "./base";

// Survey Notifications API - handles notification/sharing management
export const surveyNotificationsApi = surveyApi
  .enhanceEndpoints({
    addTagTypes: ["SurveyNotifiers"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSurveyNotifiers: build.query<SurveyNotifiersResponse, string>({
        query: (surveyId) => ({
          url: `/notification/survey/${surveyId}`,
        }),
        providesTags: (_result, _error, surveyId) => [
          { type: "SurveyNotifiers", id: surveyId },
        ],
      }),
      createSurveyNotifier: build.mutation<
        SurveyNotifier,
        { email: string; surveyId: string }
      >({
        query: ({ email, surveyId }) => ({
          url: `/notification`,
          method: "POST",
          body: { email, surveyId },
        }),
        invalidatesTags: () => ["SurveyNotifiers"],
      }),
      deleteSurveyNotifier: build.mutation<void, string>({
        query: (notifierId) => ({
          url: `/notification/${notifierId}`,
          method: "DELETE",
        }),
        invalidatesTags: () => ["SurveyNotifiers"],
      }),
      updateSurveyNotifier: build.mutation<
        void,
        { notifierId: string; updates: Partial<SurveyNotifier> }
      >({
        query: ({ notifierId, updates }) => ({
          url: `/notification/${notifierId}`,
          method: "PATCH",
          body: updates,
        }),
        invalidatesTags: () => ["SurveyNotifiers"],
      }),
    }),
  });

export const {
  useGetSurveyNotifiersQuery,
  useCreateSurveyNotifierMutation,
  useDeleteSurveyNotifierMutation,
  useUpdateSurveyNotifierMutation,
} = surveyNotificationsApi;
